import _extends from "/var/lib/jenkins/jobs/EV/jobs/NextJS/jobs/02-cert-build/workspace/target/checkout/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
var __jsx = React.createElement;
import React, { useState } from "react";
import { Events } from "services/adobeAnalytics";
import { ELSButton } from "components/common/elsevier/Button/Button";
import useDatabases from "components/fragments/Search/shared-components/Tabs/Databases/hook";
import Drawer from "./Drawer";

/* eslint no-unused-vars: "off" */
// Wraps display text with button that opens drawer when clicked
function DrawerLink(props) {
  var _useState = useState(false),
    showDrawer = _useState[0],
    setShowDrawer = _useState[1];
  var _useState2 = useState(true),
    dbSelection = _useState2[0],
    setDbSelection = _useState2[1];
  var _useDatabases = useDatabases(),
    availableDBs = _useDatabases.availableDBs,
    select = _useDatabases.sessionDBs.select;
  var handleUpdateClose = function handleUpdateClose() {
    if (dbSelection) {
      setShowDrawer(!showDrawer);
    }
  };
  var handleToggleShowDrawer = function handleToggleShowDrawer() {
    setShowDrawer(!showDrawer);
    Events.startPage.databaseDrawerClicked();
  };
  var handleValidateDBSelection = function handleValidateDBSelection(isValid) {
    setDbSelection(isValid);
  };
  var renderDBName = function renderDBName(dbMask) {
    // EV-14550: updated with null check to avoid client side error
    var selectedDb = availableDBs.find(function (db) {
      return db.mask === dbMask;
    });
    return selectedDb ? selectedDb.label : "no";
  };
  function renderTitle(length) {
    if (!dbSelection) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, "no database is selected");
    }
    switch (length) {
      case 0:
        return /*#__PURE__*/React.createElement(React.Fragment, null, "no database is selected");
      case 1:
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, renderDBName(select[0])), " database is selected");
      default:
        return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("strong", null, length), " databases are selected");
    }
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    "aria-live": "assertive"
  }, /*#__PURE__*/React.createElement(ELSButton, _extends({
    className: "es-link__black--16-font",
    type: "button",
    onClick: handleToggleShowDrawer,
    "data-cy": "database-drawer-button"
  }, props), /*#__PURE__*/React.createElement("span", {
    "data-cy": "database-drawer-button-title"
  }, renderTitle(select.length)))), /*#__PURE__*/React.createElement(Drawer, {
    updateClose: handleUpdateClose,
    drawerState: showDrawer,
    validateDBSelection: handleValidateDBSelection,
    dbSelection: dbSelection
  }));
}
DrawerLink.defaultProps = {};
export default DrawerLink;